var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPakistan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_8447)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 16.5485 2.53073 20.5057 6.26086 22.5409V1.45908C2.53073 3.49434 0 7.45148 0 12Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0C9.9211 0 7.96575 0.528891 6.26086 1.45908V22.5409C7.96575 23.4711 9.9211 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37262 18.6274 0 12 0Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1306 13.9846C15.6125 15.0815 13.4925 14.74 12.3956 13.2219C11.2987 11.7038 11.6401 9.58384 13.1583 8.48696C13.6316 8.14496 14.1635 7.94279 14.7045 7.87252C13.6636 7.71685 12.5632 7.95141 11.6427 8.61652C9.77428 9.96662 9.35395 12.5757 10.704 14.4443C12.054 16.3126 14.6632 16.733 16.5317 15.3828C17.4523 14.7177 18.0205 13.7468 18.1994 12.7095C17.9629 13.201 17.604 13.6425 17.1306 13.9846Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0656 7.8262L17.9208 8.74781L19.0615 8.21944L18.4492 9.31744L19.3043 10.2391L18.0708 9.99609L17.4585 11.0942L17.3085 9.84591L16.0749 9.60286L17.2157 9.07448L17.0656 7.8262Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_8447"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPakistan);
export default __webpack_public_path__ + "static/media/pakistan.8916d2b262c7fc2be05f9a14fb748287.svg";
export { ForwardRef as ReactComponent };